module.exports = __webpack_public_path__ + "static/media/close.a0e51a85.svg";